import Duck from "redux-ducks-ts"

export const reportCommercial = new Duck("reportCommercial", "cargo")
